import axios from '../../service/index'
import React from 'react'
import { Button, Upload, message } from 'antd'
// const qiniuUpUrl = window.location.protocol === "https:" ? 'https://up-z1.qiniup.com' : 'http://up-z1.qiniup.com/';
const qiniuUpUrl = 'https://up-z1.qiniup.com'
class UploadVideo extends React.Component {

	constructor(props) {
		super(props)
		let fileList =[]
		let proposalSize = 'MP4、AVI、MOV、WMV'
		let accept=".mp4,.avi,.mov,.wmv"
			if(props.value){
				fileList = [props.value] || []
			}
			if(props.id === 'bootVideo'){
				accept = ".mp4"
				proposalSize = 'MP4'
			}
			// console.log(props)
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: fileList,
			accept: accept,
			token: '',
			url: '',
			uploadUrl: '',
			previewVisible: false,
			type: '',
			percent: 0,
			percentShow: false,
			token2: '',
			url2: '',
			token3: '',
			url3: '',
			proposalSize: proposalSize
		}
	}
	// static getDerivedStateFromProps(nextProps,prevState){
	// 	console.log(nextProps)
	// 	return null
	// }
	handleOk() {
		this.setState({ visible: false })
	}
	
	componentDidMount() {
		// if(this.props.checksType!== 'checke'){
			// this.getType()
		// }
		this.getToken()
		this.gettoken2()
	}
	getToken(name) {
		let _this = this;
		axios.get(`/uplodController/get7menrToken?fileName=${name||''}`).then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	
	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.fileList.length<=0&&nextProps.value?.url) {
			let fileList = []
			fileList = [nextProps.value] || []
			return {fileList }
		}
		return null;
	}
	handlePreview = async file => {
		this.setState({
			previewVisible: true,
		  });
	}
	handleChange = ({ file,fileList }) => {
		// console.log(fileList)
		this.props.onChange(fileList)
		this.setState({percent: Math.floor(file.percent)},()=>{
			if(this.state.percent>=0){
				this.setState({percentShow: true})
			}
			if(file.percent === 100) {
				this.setState({percentShow: false})
			}
		})
		if(file.percent === 100){
			if (file.status === 'done') {
				file.type = this.state.type
				this.setState({
					uploadUrl: this.state.url + '/' + file.response.key
				})
				let fileL ={
                    uid: fileList[0].uid,
                    name: fileList[0].name,
                    status: fileList[0].status,
                    url: this.state.url+'/'+fileList[0].response.hash,
										type: fileList[0].type
                }
				this.setState({ fileList: [fileL] });
				this.props.getQiniuUrl(this.state.uploadUrl)
				this.props.onChange(fileList)
			}
		}
		else if(file.status === 'removed'){
			this.setState({ fileList: [] });
		}
	};
	uploadMethod = (file, fileList) => {
		console.log(file)
		return new Promise(async(resolve, reject) => {

			if(fileList.length>1) return message.warning("只能上传一个文件")
			this.setState({type:file.type})
			if(this.props.checksType!== 'checke'){ // 上传
				this.setState({ fileList: fileList })
				resolve(true)
			}else{
				//页面添加Loading效果
				message.loading('上传中...',0)
				await this.getToken(file.name)
				await this.gettoken2(file.name)
			
				let formdata = new FormData()
				formdata.append('file', file)
				const {data: res} = await axios.post('outlineController/checkVideoIsExists', formdata)
				//关闭Loading效果
				message.destroy()

				if(res.code !== '200')message.error(res.msg)
				if(res.data.checkeResult){
				// 		console.log(fileList)
				// file.type = this.state.type
				this.setState({
					uploadUrl: res.data.bosUrl
				})
				let fileL ={
						uid: fileList[0].uid,
						name: res.data.name,
						url: res.data.bosUrl,
						md5Code: res.data.md5Code,
						// type: fileList[0].type,
						zmBosUrl: res.data.zmBosUrl||'',
						status: 'done'
				}
					this.setState({ fileList: [fileL] });
					// this.setState({ fileList: fileList })
					this.props.getQiniuUrl(res.data.bosUrl)
					// this.props.onChange(fileList)
					this.props.onChange([fileL])
					return false // 已存在
				}else{
					this.setState({ fileList: fileList })
					resolve(true)
				}
			}
			// })
		})
		
	}
	showModal() {
		this.setState({ visible: true })
	}
	handleCancel = () => this.setState({ previewVisible: false });
	getType() {
		let _this = this;
		axios.get(`/uplodController/get7menrToken?type=1`).then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token3: res.data.data.token,
					url3: res.data.data.url
				})
				this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	gettoken2(name) {
		let _this = this;
		axios.get(`/uplodController/get7menrToken?type=1&fileName=${name||''}`).then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token2: res.data.data.token,
					url2: res.data.data.url
				})
				this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	getdata = (file )=> {
		console.log(file)
		return new Promise((resolve)=>{
		
		})
		
	}
	getQiniu=   (file)=> {
		let data = {
			token: '',
			name: file.name
		}
		// console.log(this.props)
		// if(this.props.checksType!== 'checke') {
		// 	data = {
		// 		token: this.state.token3,
		// 		name: file.name
		// 	}
		// 	return {token: data.token}
		// }
		if(file.type.split('/')[1]!=='mp4'){
			data = {
				token: this.state.token2,
				name: file.name
			}
		}else {
			data = {
				token: this.state.token,
				name: file.name
			}
		}
		return {token: data.token}
	}
	componentWillUnmount() {
		this.setState = () => false;
 }
	render() {
		const {fileList, percentShow, accept, proposalSize} = this.state;
		const uploadButton = (
            <div>
                <Button>上传</Button>
				<p style={{fontSize: '12px',color: '#999999'}}>支持格式{proposalSize}，大小不超过1GB</p>
				<p style={{fontSize: '12px',color: '#999999'}}>只能上传一个视频</p>
            </div>
        );
		return (
			<div>
				<Upload
					accept= {accept}
					action={qiniuUpUrl}
					fileList={fileList}
					beforeUpload={this.uploadMethod}

					onPreview={this.handlePreview}
					onChange={this.handleChange}
					onRemove={(file, fileList)=>{
						// this.setState({fileList: []},()=>{
							this.props.onChange({})
						// })
						
					}}
					data={this.getQiniu}
				>
					{this.state.fileList.length>=1?'':uploadButton}
					
				</Upload>
				{percentShow?<span>上传中请稍后...{this.state.percent}%</span>:''}
				{/* <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="example" style={{width: '100%'}} src={uploadUrl}/>
                </Modal> */}
			</div>
		)
	}
}

export default UploadVideo
